import messages from '@/locales/messages.json'

export default defineI18nConfig(() => {
    const localeCookie = useCookie('LOCALE')
    const router = useRouter()

    let allMessages = messages
    let allLocales = Object.keys(allMessages)

    let languageFromUrl = router.currentRoute.value.query.lang as string
    if (languageFromUrl) {
        localeCookie.value = languageFromUrl
    }

    let currentLocale = allLocales.includes(localeCookie.value) ? localeCookie.value : 'nb'

    return {
        legacy: false,
        locale: currentLocale,
        messages: messages,
        locales: allLocales,
        fallbackLocale: 'nb',
        defaultLocale: 'nb'
    }
})
